// extracted by mini-css-extract-plugin
export var btnRoot = "header-module--btnRoot--rlzlw";
export var label = "header-module--label--AKd1n";
export var plait = "header-module--plait--Q8ih-";
export var root = "header-module--root--UEddj";